import {ThunkDispatch} from "redux-thunk";
import {AnyAction} from "redux";
import {connect} from "react-redux";
import {Squad} from "../../../../client/api";
import {performAction} from "../../../../store/actions/all";
import {RootState} from "../../../../store";
import {fetchPositions} from "../../../../store/actions/teamActions";
import {IDType} from "../../../../config/types";

const mapper = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
    getPositions: () => {
        performAction({f: fetchPositions, p: [dispatch]});
    },
});

const props = (
    state: RootState,
    prevProps: { player?: Squad, close: (newPlayer?: Squad | IDType) => void, teamId: IDType }
) => ({
    positions:
    state.team.positions,
    ...prevProps,
});

export const connector = connect(props, mapper);
